import {apiPath} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {ICreditOffer} from "../types/ICreditOffer";

const creditOffersLink = apiPath.credit.base;

export interface ICreditOffersPayload {
    property_price: number;
    own_contribution: number;
    term_of_the_loan: number;
    credit_amount: number;
}

interface IQuery {
    count: number;
    results: ICreditOffer[];
}

export const getCreditOffersList = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getCreditOffers: build.query<IQuery, ICreditOffersPayload>({
            query: (params) => {
                return {
                    url: creditOffersLink,
                    params: {
                        ...params
                    }
                };
            }
        })
    })
});

export const {useGetCreditOffersQuery} = getCreditOffersList;
import {apiPath} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {ICreditOffer} from "../types/ICreditOffer";

const creditOffersLink = apiPath.credit.base;

export interface ICreditOffersPayload {
    property_price: number;
    own_contribution: number;
    term_of_the_loan: number;
    credit_amount: number;
}

interface IQuery {
    count: number;
    results: ICreditOffer[];
}

export const getCreditOffersList = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getCreditOffers: build.query<IQuery, ICreditOffersPayload>({
            query: (params) => {
                return {
                    url: creditOffersLink,
                    params: {
                        ...params
                    }
                };
            }
        })
    })
});

export const {useGetCreditOffersQuery} = getCreditOffersList;
